import { IPaymentListItem } from 'modules/accommodations/features/reservations/models';

export const findElementByCalculationPaymentId = ({
  payments,
  calculationPaymentId,
}: {
  payments: IPaymentListItem[];
  calculationPaymentId: string;
}) => {
  return payments.find(
    (paymentItem: IPaymentListItem) => paymentItem.calculationPaymentId === calculationPaymentId,
  );
};
